import React from "react";
import { DateTime } from "luxon";
import { isEmbargoActive } from "../../../../domain/listingEmbargo";
import { CRMNoticeBoxComponent } from "../CRMNoticeBoxComponent/CRMNoticeBoxComponent";
import { WeightBold } from "../WeightBold/WeightBold";

// Carries the year, unlike the valuation status bar's "d MMM": a hold runs up to 90
// days ahead and a bare day and month reads as the past once it crosses new year.
const formatEmbargoDate = (isoDate: string): string =>
    DateTime.fromISO(isoDate).setZone("Europe/London").toFormat("d MMM yyyy");

// Renders nothing once the date has passed. The column is deliberately not cleared
// when the hold is released - the release task keys off val_case_id, and the date is
// kept as a record of what the introducer asked for - so a banner that only checked
// for a date would still be warning staff off years later.
export const CRMListingEmbargoBanner = (props: {
    doNotContactUntil: string | null;
    children?: React.ReactNode;
}): JSX.Element | null =>
    isEmbargoActive(props.doNotContactUntil) && props.doNotContactUntil !== null
        ? <CRMNoticeBoxComponent>
            <WeightBold>Do not contact until {formatEmbargoDate(props.doNotContactUntil)}.</WeightBold>
            {props.children}
        </CRMNoticeBoxComponent>
        : null;
